import Logger from './logger';

global.requestIdleCallback =
  global.requestIdleCallback ||
  (handler =>
    setTimeout(() => {
      const startTime = Date.now();
      handler({
        didTimeout: false,
        timeRemaining: () => {
          return Math.max(0, 50.0 - (Date.now() - startTime));
        }
      });
    }, 100));

const CALLBACK_TIMEOUT = 500;

function queueProcessor(deadline, queue) {
  return new Promise(resolve => {
    while (
      (deadline.timeRemaining() > 0 || deadline.didTimeout) &&
      queue.messageQueue.length &&
      queue.started
    ) {
      const event = queue.messageQueue.shift();
      event.handler(event.name, event.payload);
    }
    resolve(queue);
  });
}

export default class MessageQueue {
  constructor() {
    this.logger = Logger.getLogger();
    this.taskHandle = 0;
    this.started = false;
    this.messageQueue = [];
  }

  startProcessing() {
    this.logger.info('starting the message queue');
    this.started = true;

    if (this.messageQueue.length > 0 && !this.taskHandle) {
      this.taskHandle = requestIdleCallback(this.processQueue.bind(this), {
        timeout: CALLBACK_TIMEOUT
      });
    }
  }

  stopProcessng() {
    this.started = false;
  }

  enqueue(handler, name, payload) {
    this.messageQueue.push({ handler, name, payload });

    if (this.started && !this.taskHandle) {
      this.taskHandle = requestIdleCallback(this.processQueue.bind(this), {
        timeout: CALLBACK_TIMEOUT
      });
    }
  }

  /* eslint-disable no-param-reassign */
  processQueue(deadline) {
    queueProcessor(deadline, this).then(queue => {
      if (queue.messageQueue.length && queue.started) {
        queue.taskHandle = requestIdleCallback(queue.processQueue.bind(queue), {
          timeout: CALLBACK_TIMEOUT
        });
      } else {
        queue.taskHandle = 0;
      }
    });
  }
  /* eslint-enable no-param-reassign */
}
